import React from "react";
import { Link } from "react-router-dom";
import { BrandMark } from "./BrandMark";

/**
 * Generic placeholder page used by every route that's not yet implemented.
 * Renders BrandMark + page title + "Coming in Session X" + back-to-home link.
 */
export const PlaceholderPage = ({
  title,
  session,
  description,
  testId,
}) => {
  return (
    <main
      data-testid={testId || "placeholder-page"}
      className="min-h-screen bg-napoli-cream text-napoli-espresso flex flex-col items-center justify-center px-6 py-16"
    >
      <div className="w-full max-w-2xl flex flex-col items-center text-center animate-fade-up">
        <BrandMark size="md" theme="light" to="/" linkTestId="placeholder-brand-link" />

        <div className="mt-12 flex items-center gap-3">
          <span className="h-px w-10 bg-napoli-gold" aria-hidden />
          <span className="font-body text-[11px] tracking-[0.28em] uppercase text-napoli-oxblood">
            Napoli Rewards
          </span>
          <span className="h-px w-10 bg-napoli-gold" aria-hidden />
        </div>

        <h1
          data-testid="placeholder-title"
          className="mt-4 font-display font-bold text-4xl sm:text-5xl lg:text-6xl text-napoli-espresso tracking-tight"
        >
          {title}
        </h1>

        {description ? (
          <p className="mt-5 font-body text-base sm:text-lg text-napoli-espresso-soft max-w-lg leading-relaxed">
            {description}
          </p>
        ) : null}

        <div
          data-testid="placeholder-session-tag"
          className="mt-10 inline-flex items-center gap-2 border border-napoli-gold/60 px-5 py-2"
        >
          <span className="h-1.5 w-1.5 rounded-full bg-napoli-gold" aria-hidden />
          <span className="font-body text-xs tracking-[0.24em] uppercase text-napoli-espresso-soft">
            Coming in Session {session}
          </span>
        </div>

        <Link
          to="/"
          data-testid="placeholder-home-link"
          className="mt-12 font-body text-sm tracking-[0.18em] uppercase text-napoli-oxblood hover:text-napoli-oxblood-dark transition-colors"
        >
          ← Return to the table
        </Link>
      </div>
    </main>
  );
};

export default PlaceholderPage;
